import type { AnswerType, QuestionAnswerType } from '~/hooks/omniform/types';
import type { getSelfIntakeHouseData } from '~/types/generated/getSelfIntakeHouseData';
import { roundAmount } from '~/utils/rounding';
import { QKeyGeneral } from './types';
import type { IntakeTextVariables } from './types';
import type { EnergyPrices } from '@energiebespaarders/constants/calculations/utils';

export const getVariablesFromHouse = (
  houseData: getSelfIntakeHouseData,
  personalEnergyPrices: EnergyPrices,
) => {
  const {
    constructionYear,
    situation: { consumption },
    energy,
  } = houseData.house;
  const gasConsumption = roundAmount(consumption.gas ?? energy.gasConsumption, 100);
  const electricityConsumption = roundAmount(
    consumption.electricity ?? energy.electricityConsumption - energy.electricityProduction,
    100,
  );
  const gasConsumptionMonthlyCost = roundAmount(
    (gasConsumption * personalEnergyPrices.gas) / 12,
    1,
  );
  const electricityConsumptionMonthlyCost = roundAmount(
    (electricityConsumption * personalEnergyPrices.electricity) / 12,
    1,
  );
  return {
    constructionYear,
    gasConsumption,
    electricityConsumption,
    gasConsumptionMonthlyCost,
    electricityConsumptionMonthlyCost,
  };
};

export const getUpdatedTextVariablesFromAnswer = (
  questionKey: string,
  answer: AnswerType<QuestionAnswerType>,
  personalEnergyPrices: EnergyPrices,
): Partial<IntakeTextVariables> => {
  if (questionKey === QKeyGeneral.HouseGasConsumption) {
    const gasConsumptionMonthlyCost = roundAmount(
      ((answer as number) * personalEnergyPrices.gas) / 12,
      1,
    );
    return { gasConsumptionMonthlyCost };
  }
  if (questionKey === QKeyGeneral.HouseElectricityConsumption) {
    const electricityConsumptionMonthlyCost = roundAmount(
      ((answer as number) * personalEnergyPrices.electricity) / 12,
      1,
    );
    return { electricityConsumptionMonthlyCost };
  }
  if (questionKey === QKeyGeneral.HousePVPanelAmount) {
    const averagePanelPower = 370;
    const electricityProduction = roundAmount((answer as number) * averagePanelPower * 0.85, 10);
    return { electricityProduction };
  }
  return {};
};
